<div class="container-fluid gx-0 d-flex flex-column min-vh-100 app-bg-color">
    <!-- <app-header-new></app-header-new> -->
  <!-- <div class="row gx-0 flex-grow-1" >
    <div class="col content">
       -->
      <div class="mx-auto mx-lg-0 w-312">
        <h1 class="fw-medium fs-30">Kundensuche</h1>
        <p class="description mt-4 mb-3 col-md-12 col-lg-7">
          Für eine Änderung bitte den Kunden hier suchen.
        </p>
        <form class="mt-4 mb-3 mb-md-4 screen-button" [formGroup]="customerSearchForm">
            <div class="mb-3">
              <label for="firstName" class="form-label">Vorname</label>
              <div class="input-group">
                <input formControlName="firstName" type="text" class="form-control" maxlength="30" minlength="2" />
              </div>

              <div *ngIf="
                  f['firstName'].invalid &&
                  (f['firstName'].dirty || f['firstName'].touched)
                " class="invalid-feedback mt-0">
                <div *ngIf="
                    f['firstName'].errors?.['required'] || f['firstName'].errors
                  ">
                  Bitte geben Sie Ihren Vornamen ein.
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label for="Nachname" class="form-label">Nachname</label>
              <div class="input-group">
                <input type="text" class="form-control" id="Nachname" formControlName="lastName" maxlength="30"
                  minlength="2" />
              </div>
              <div *ngIf="
                  f['lastName'].invalid &&
                  (f['lastName'].dirty || f['lastName'].touched)
                " class="invalid-feedback mt-0">
                <div *ngIf="
                    f['lastName'].errors?.['required'] || f['lastName'].errors
                  ">
                  Bitte geben Sie Ihren Nachnamen ein.
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="dob" class="form-label">Geburtsdatum</label>
              <div class="col-12 date">
                <input type="date" formControlName="dob" max="2999-12-31" autocomplete="off" class="form-control"
                  (focus)="focusDob()" />
                <span class="open-button">
                  <button type="button" tabindex="-1">
                  </button>
                </span>
              </div>
                 <!-- <div class="date">
        <input type="date" formControlName="dob" max="2999-12-31" autocomplete="off" class="form-control" id="seit"
          title="Seit"  bootstrapValidation required scrollToOnFocus />
      </div> -->
    <div *ngIf="
                  f['dob'].invalid &&
                  (f['dob'].dirty || f['dob'].touched) &&
                  !f['dob'].hasError('underAge')
                " class="invalid-feedback mt-0">
                <div *ngIf="f['dob'].errors?.['required'] || f['dob'].errors">
                  Bitte geben Sie ein gültiges Geburtsdatum an.
                </div>
              </div>
            </div>

          <button type="submit" class="btn btn-primary btn-nav fs-18 ms-auto seek-btn"
            [disabled]="!customerSearchForm.valid || customDobError" (click)="onCustomerSearch(customerSearchForm)">
            Suchen
          </button>

          <div *ngIf="enableResultSection">
            <div class="mt-4_5" formArrayName="selectCustomer" *ngIf="customerList.length > 1">
              <h5>Bitte wählen Sie den Kunden:</h5>
              <span class="description fs-14">{{ customerList.length }} Kunden gefunden</span>
              <ul class="list-group list-group-flush col-md-9 mt-3 result-section">
                <li class="list-group-item d-flex align-items-start bg-white"
                  *ngFor="let item of customers.controls; let i = index">
                  <ng-container [formGroupName]="i">
                    <input class="form-check-input me-1 mt-2 col-2" type="radio" formControlName="selected"
                      name="selected" (change)="onResultSelection()" [value]="true" [id]="i" checked />
                    <div class="ms-4 col-auto">
                      <label class="form-check-label stretched-link text-secondary fw-regular mb-0" [for]="i">
                        <span class="d-block">{{ item.value.name }}, &nbsp;{{
                          item.value.entity
                          }}
                          - {{ item.value.number }}</span>
                        <span class="d-block">{{ item.value.address }}</span>
                      </label>
                    </div>
                  </ng-container>
                </li>
              </ul>
            </div>

            <div class="mt-4_5" formArrayName="selectCustomer" *ngIf="customerList.length === 1">
              <ul class="list-unstyled" *ngFor="let item of customers.controls; let i = index">
                <ng-container [formGroupName]="i">
                  <li class="fs-14">
                    Vorname, Nachname:
                    <b class="fw-book">{{ item.value.name }}</b>
                  </li>
                  <li class="fs-14">
                    Gerburtsdatum:
                    <b class="fw-book">{{ item.value.birthDate }}</b>
                  </li>
                  <li class="fs-14">
                    Address:
                    <b class="fw-book">{{ item.value.address }}</b>
                  </li>
                </ng-container>
              </ul>
            </div>

            <div class="invalid-feedback mt-3" *ngIf="customerList.length === 0">
              Es wurde kein Kunde gefunden.
            </div>
          </div>
          <div class="row gx-0 mt-5">
            <app-bottom-nav [backHidden]="false" [cancelHidden]="true" (nextClicked)="onSubmit(customerSearchForm)"
             
              (backClicked)="onBack()"
              [nextDisabled]="
                !customerSearchForm.valid ||
                customerList.length === 0 ||
                !enableSubmit
              " nextCaption="Weiter">
            </app-bottom-nav>
          </div>
           <!-- <div class="row gx-0 mt-5">
            <app-bottom-nav [backHidden]="false" [cancelHidden]="true" (nextClicked)="onSubmit(customerSearchForm)"
              [backRoute]="backRoute" [nextDisabled]="
                !customerSearchForm.valid 
              " nextCaption="Weiter">
            </app-bottom-nav>
          </div> -->
        </form>
        </div>
      <!-- </div>
    </div> -->
  <!-- <app-footer></app-footer> -->
</div>